import styled from 'styled-components';

import BranchCheckbox from '../components/BranchCheckbox';

export const DeliveryCheckbox = styled(BranchCheckbox)`
  margin-right: 8px;
  margin-bottom: 8px;
`;
